/*
 *   Copyright (c) 2026 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/telemetry.config.json';
import axios from 'axios';
import { LoggerModule } from '@vlinder-web/logger-module-react';

const log: any = LoggerModule.getInstance();

export interface ITelemetryEventMethods extends IPluginMethodMap {
  recordEvent(args: any): Promise<any>;
}

export class TelemetryEventService implements IAgentPlugin {
  readonly methods: ITelemetryEventMethods;

  constructor() {
    this.methods = {
      recordEvent: this.recordEvent.bind(this),
    };
  }

  async recordEvent(args: any) {
    try {
      const res = await axios.post(
        `${args.apiURL}${config?.telemetryEventEP}`,
        args.payload,
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'org-id': args.payload?.orgId || 'DIAGE',
            'org_id': args.payload?.orgId || 'DIAGE',
          },
        }
      );
      return res?.data;
    } catch (err: any) {
      log?.debug?.('Telemetry recordEvent error:', err?.message);
      return false;
    }
  }
}
